export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11984.f20b612a.jpg";